import {
    ProductShippingService,
    productShippingServiceDecoder
} from './ProductShippingService'
import {Customer, customerDecoder} from './Customer'
import {array, Decoder, field, object} from 'json-bouncer'

export interface ProductCalculationImportBaseData {
    readonly availableShippingServices: ProductShippingService[],
    readonly availableCustomers: Customer[]
}

export function productCalculationImportBaseDataDecoder(): Decoder<ProductCalculationImportBaseData> {
    return object({
        availableShippingServices: field(
            'availableShippingServices',
            array(productShippingServiceDecoder())
        ),
        availableCustomers: field(
            'availableCustomers',
            array(customerDecoder())
        ),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/ProductCalculationImportBaseData.ts